import { Button } from "@mui/material";

interface Props {
  isD2C?: boolean;
  openComparePlansModal(state: boolean): void;
}

export function ComparePlansButton({ isD2C, openComparePlansModal }: Props) {
  return (
    <Button
      onClick={() => openComparePlansModal(true)}
      data-testid="compare-plans-button"
      size="small"
      variant="outlined"
      sx={{
        maxWidth: isD2C ? "200px" : undefined,
      }}
      fullWidth>
      Compare Plans
    </Button>
  );
}
